/**
 * Decode JWT payload (middle segment) without verifying the signature.
 * Used only to align client-side routes with server-verified claims (e.g. preview `galleryId`).
 */
export function decodeJwtPayload(token) {
  if (typeof token !== 'string' || token.length === 0) {
    return null;
  }
  try {
    const parts = token.split('.');
    if (parts.length < 2) {
      return null;
    }
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padLen = (4 - (base64.length % 4)) % 4;
    const padded = base64 + '='.repeat(padLen);
    const json = atob(padded);
    return JSON.parse(json);
  } catch {
    return null;
  }
}
